import { render, staticRenderFns } from "./relatedgoods.vue?vue&type=template&id=e743a15a&scoped=true"
import script from "./relatedgoods.vue?vue&type=script&lang=js"
export * from "./relatedgoods.vue?vue&type=script&lang=js"
import style0 from "./relatedgoods.vue?vue&type=style&index=0&id=e743a15a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e743a15a",
  null
  
)

export default component.exports